import { useFeatureFlag } from "shared-ui/src/utils/FeatureFlagHelper";

const PROFILE_DRAWERS_FLAG = "nomads.enable-profile-drawers";

export default function useProfileDrawersEnabled() {
  const localProfileDrawersEnabled = import.meta.env.MODE === "development";
  const { enabled: profileDrawersFlagEnabled } = useFeatureFlag(
    PROFILE_DRAWERS_FLAG,
    localProfileDrawersEnabled,
  );

  return localProfileDrawersEnabled || Boolean(profileDrawersFlagEnabled);
}
